import { Button, CCheckbox, CDropdown, CInputControl } from "core/components/form-controls";
import AppLayout from "core/layouts/AppLayout";
import { useEffect, useRef, useState } from "react";
import { REGEX } from "core/config/constant";
import { useCustomNavigate, useNavigateStackCustom } from "core/hooks/useCustomNavigate";
import { RouterName, route } from "core/router";
import { useFormikCustom } from "core/hooks/useFormikCustom";
import { getFieldCheckboxProps, getFieldInputProps } from "core/utils/form";
import { _t } from "core/language";
import { useLoginClient } from "../hooks";
import { settingApplication, setupAxios } from "core/networks/API";
import ButtonLoginSns from "./components/ButtonLoginSns";
import Icon from 'core/assets/icons';
import { useSelector } from "react-redux";
import { useAppSetting } from "modules/AppSettings/hooks";
import { useAuthModal } from 'core/context';
import PageHeader from "core/components/Header/PageHeader";

export enum LanguageTypeEnum {
  APPLE = 'APPLE',
  FACEBOOK = 'FACEBOOK',
  GOOGLE = 'GOOGLE',
}

const LoginPage = () => {
  const { callPrevAction, isModalOpen } = useAuthModal()
  const navigate = useCustomNavigate();
  const {loginFailed} = useSelector((state: any) => state.Auth);
  const appSetting = useAppSetting();
  const [pageBack, setPageBack] = useState(-1);
  const [typeLoginSns, setTypeLoginSns] = useState('');
  const [loginByMenu, setLoginByMenu] = useState('');
  const [fromForgotPw, setFromForgotPw] = useState('');
  const [urlBackPage, setUrlBackPage] = useState('');
  const { getLastRoute } = useNavigateStackCustom();
  const lastRoute = getLastRoute(true);
  const _onSuccess = () => {
    
    console.log(lastRoute,'lastRoute login page', pageBack)
    if(loginByMenu){
      navigate(RouterName.MAIN)
      return
    }
    if(signUpByMenu){
      navigate(RouterName.MAIN)
      return
    }
    if(fromForgotPw){
      navigate(RouterName.MAIN)
      return
    }
    if(!isModalOpen && !typeLoginSns){
      navigate(pageBack !== -1 ? lastRoute : -1)
      callPrevAction?.()
    }
  };

  const _onFailed = (errors: any) => {
    formik.setErrors({ password: errors?.msg || 'ERROR SERVER' })
  };

  const {handleLogin} = useLoginClient({
    onSuccess: _onSuccess,
    onFailed: _onFailed,
  });

  const formik = useFormikCustom({
    initialValues: {
      email: "", //phpteam@gmail.com
      password: "", //abcd1234
      remember: false,
      validSubmit: false
    },
    validateOnMount: true,
    enableReinitialize: true,
    onSubmit(values, formikHelpers) {
      const dataSubmit = {
        email: values.email,
        password: values.password,
        remember: values?.remember ? 1 : 0,
        type: ""
      }
      handleLogin(dataSubmit);
      setTimeout(() => {
        formikHelpers.setSubmitting(false)
      }, 2000)
    },
  });

  const [selectedLang, setSelectedLang] = useState<string>('1')
  const [languages, setLanguages] = useState([]);
  const [signUpByMenu, setSignUpByMenu] = useState('');

  const formikRef = useRef(formik);
  useEffect(() => {
    formikRef.current = formik;
  }, [formik]);


  useEffect(() => {
    if(location?.search && location?.search.includes('signupSuccess')){  
      setPageBack(-4)
    }
    if(location?.search && location?.search.includes('backPage')){  
      const url = new URLSearchParams(location?.search).get('backPage');
      if(url){
        setUrlBackPage(url)
      }
    }
    if(location?.search && location?.search.includes('loginByMenu')){  
      setLoginByMenu('loginByMenu')
      setUrlBackPage(RouterName.MENU)
    }
    if(location?.search && location?.search.includes('signUpByMenu')){  
      const url = new URLSearchParams(location?.search).get('signUpByMenu');
      if(url){
        setSignUpByMenu(url)
      }
    }
  }, [location])

  useEffect(() => {
    if(appSetting?.languages && appSetting?.languages.length > 0 && appSetting?.languages){
      setLanguages(appSetting?.languages)
      // @ts-ignore
      setSelectedLang(appSetting?.languages.find((item: any) => item?.code === window._APP_LANG)?.id || 1)
    }
    
  },[appSetting?.languages])

  useEffect(() => {
    if(loginFailed && loginFailed?.code === 422){
      // formik.setErrors({ password: _t('auth.AU_01_MSG_01') })
      formikRef.current.setErrors({ password: _t('auth.AU_01_MSG_01') })
    }
  }, [loginFailed])

  // useEffect(() => {
  //   formik.setValues((pre) => ({
  //     ...pre,
  //     validSubmit: (formik.values?.password && formik.values?.email ? true : false),
  //   }));
  //   // console.log('formail')
  // }, [formik.values?.password, formik.values?.email])
  
  useEffect(() => {
    const isValidSubmit = !!(formikRef.current.values.password && formikRef.current.values.email);
    if (formikRef.current.values.validSubmit !== isValidSubmit) {
      formikRef.current.setFieldValue('validSubmit', isValidSubmit);
    }
  }, [formik.values.password, formik.values.email]);

  const changeLanguage = (value: any) => {
    const codeLang:any = languages.find((item:any) => item.id === value)
    setSelectedLang(value);
    (window as any)._APP_LANG = codeLang?.code;
    settingApplication()
    setupAxios()
    // @ts-ignore
    window.webviewResponeLanguage({ lang: codeLang.code });
  }

  const submitLogin = (e: any) => {
    const { onSubmit } = formik;
    onSubmit(e)
  };

  useEffect(() => {
    console.log(lastRoute,'lastRoute login page 0')
    localStorage.removeItem('dataPolicy')
    const forgotPw = localStorage.getItem('forgotPw')
    if(forgotPw){
      setFromForgotPw(forgotPw)
      localStorage.removeItem('forgotPw')
    }
    if ((window as any).webViewCallGetListPath) {
      (window as any).webViewCallGetListPath([(window as any).location?.pathname])
    }
    (window as any).backFromDeviceAndroid = function() {
      handleGoBack()
    }
    return () => {
      (window as any).backFromDeviceAndroid = undefined
    }
  }, [])

  const handleGoBack = () => {
    navigate(RouterName.MAIN)
  }

  const handleGetTypeSns = (type:any) => {
    setTypeLoginSns(type)
  }

  return (
    <AppLayout className={"login-client-page"}>
      <PageHeader isShowBorder={false} sticky showCart={false} title={''} handleGoBack={handleGoBack} />
      <div className="flex overflow-hidden flex-col px-4">

        <nav className="flex py-[8px] justify-end fixed right-4 top-0 z-[400]">
          <CDropdown
            className="mb-3 min-w-[122px] max-h-[32px] min-h-[32px]"
            label=""
            icon={Icon.Region}
            options={languages}
            value={selectedLang}
            onChange={(value: string) => changeLanguage(value)}
            rounded
          />
        </nav>
        <main className="flex flex-col items-center pt-16 pb-32 w-full bg-white">
          <ButtonLoginSns
            hideOptionGmail={true}
            setTypeLoginSns={handleGetTypeSns}
          //  handleLogin={handleLogin} 
          />
          <div className="relative min-h-[28px] text-[13px] flex items-center mt-[30px] w-full tracking-tighter leading-loose whitespace-nowrap text-neutral-400">
            <div className="shrink-0 self-stretch my-auto h-px border border-solid border-zinc-100 w-[50%]" />
            <div className="text-[13px] tracking-tighter self-stretch absolute px-3.5 bg-white top-0 transform -translate-x-1/2 left-1/2">{_t('auth.Or')} </div>
            <div className="shrink-0 self-stretch my-auto h-px border border-solid border-zinc-100 w-[50%]" />
          </div>
          <h1 className="mt-[18px] text-xl font-bold tracking-tighter text-neutral-900">
            {_t('auth.LabelLogin')}
          </h1>
          <form onSubmit={submitLogin} className="flex flex-col self-stretch mt-[30px] mb-0 w-full text-sm font-medium">
            <CInputControl
              className="mb-3.5"
              classNameInput="!py-[14px] !text-[14px]"
              classNameIcon="!w-[15px] !h-[13.5px]"
              label=""
              error=""
              icon={Icon.ID}
              maxLength={200}
              placeholder= {_t('auth.LabelIdEmail')}
              status={REGEX.EMAIL.test(formik?.values.email) ? 'success' : (formik?.values.email ? 'fail' : '')}
              {...getFieldInputProps(formik, 'email')}
            />
            <CInputControl
              className="mb-[17px]"
              classNameInput="!py-[14px] !text-[14px]"
              classNameIcon="!w-[15px] !h-[13.5px]"
              label=""
              error=""
              icon={Icon.Password}
              maxLength={200}
              status={formik?.values.password ? 'success' : (formik?.values.password ? 'fail' : '')}
              type="password"
              placeholder= {_t('auth.Password')}
              {...getFieldInputProps(formik, 'password')}
            />
            <CCheckbox
              className=""
              label={_t('auth.LabelRememberMe')}
              {...getFieldCheckboxProps(formik, 'remember')}
            />
            <Button
              type="submit"
              primary
              label={_t('auth.LabelLogin')}
              disabled={!formik.values?.validSubmit}
              classBtn="w-full mb-3.5 mt-[33px] !py-[15px]"
              size="lg"
            />
            <div className="flex gap-2">
              <Button size="lg" 
                label={_t('auth.LabelForgotPw')} 
                onClickBtn={() => navigate(route(RouterName.FORGOT_PW_CHECK_MAIL))} 
                classBtn="w-full !py-[15px]" 
              />
              <Button size="lg" 
                label={_t('auth.LabelSignUp')} 
                onClickBtn={() => navigate(route(RouterName.SIGNUP_POLICY)+`${urlBackPage ? '?backPage='+urlBackPage : ''}`)} 
                classBtn="w-full !py-[15px]" 
              />
            </div>

          </form>
        </main>
      </div >
    </AppLayout>
  );
};

export default LoginPage;
